"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
var UserFactory = function UserFactory() {
  var user = {};

  var getUser = function getUser() {
    return user;
  };

  var isSignedIn = function isSignedIn() {
    return user.isSignedIn;
  };

  return { getUser: getUser, isSignedIn: isSignedIn };
};

exports.default = UserFactory;

// WEBPACK FOOTER //


/** WEBPACK FOOTER **
 ** ./client/app/common/user/user.factory.js
 **/